import React from 'react';

import { RandomGradProgramsBlockData } from 'api/cms';
import { Box } from 'components/Box';
import { PrimaryButtonLink } from 'components/Button';
import { H2 } from 'components/Text';
import { colors, gutterWidth } from 'theme';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { AmpRandomGradProgramsBlockPrograms } from './AmpRandomGradProgramsBlockPrograms';

type Props = {
  data: RandomGradProgramsBlockData;
};

export function AmpRandomGradProgramsBlock({ data: { headline } }: Props) {
  return (
    <Box
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      p={[gutterWidth / 2, null, gutterWidth]}
      borderRadius={[0, null, null, 48]}
      bg={colors.fog}
      textAlign="center"
    >
      {headline && <H2>{headline}</H2>}
      <PrimaryButtonLink href={`${listingSearchHomePath('GRAD_PROGRAM')}?q=`}>
        {getText('See All')}
      </PrimaryButtonLink>
      <Box mt={48}>
        <AmpRandomGradProgramsBlockPrograms />
      </Box>
    </Box>
  );
}
